/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import {OPKey} from '../../../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
import {frameworkRoute} from '../../../pages/esgManager/constants/frameworkRoutes';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';
import {
  hasAccessToReport,
  shouldBlockReportAccess
} from '../../../utils/SubscriptionHelper';

const pillarsAPI = async (
  selectedYear: string,
  shouldCall: boolean = false,
  framework: string | undefined = undefined
): Promise<any> => {
  const prevSelectedYear = useJSONStore.getState().esgPillarsSelectedYear;
  const setPrevSelectedYear = useJSONStore.getState().setEsgPillarsSelectedYear;
  const token = useUserStore.getState().userToken;
  const companyId = useCompanyStore.getState().companyId;
  const companySubCategoryId =
    useCompanyStore.getState().companyDetails?.[OPKey.SUB_CATEGORY];
  const pillars = API_ENDPOINT_JSON.ESG.pillars;
  const setEsgPillars = useJSONStore.getState().setEsgPillars;

  if (
    prevSelectedYear !== selectedYear ||
    prevSelectedYear === '' ||
    shouldCall
  ) {
    try {
      const response = await Promise.all([
        hasAccessToReport(frameworkRoute.GRI) &&
        !shouldBlockReportAccess(frameworkRoute.GRI) &&
        (framework ? framework === frameworkRoute.GRI : true)
          ? axios.request({
              method: CRUDMethods.GET,
              url: `${API_BASE_URL}${pillars.GRI}/${companyId}/${selectedYear}`,
              headers: {
                Authorization: `Bearer ${token}`
              },
              params: {},
              data: {}
            })
          : null,
        hasAccessToReport(frameworkRoute.BRSR) &&
        !shouldBlockReportAccess(frameworkRoute.BRSR) &&
        (framework ? framework === frameworkRoute.BRSR : true)
          ? axios.request({
              method: CRUDMethods.GET,
              url: `${API_BASE_URL}${pillars.BRSR}/${companyId}/${selectedYear}`,
              headers: {
                Authorization: `Bearer ${token}`
              },
              params: {},
              data: {}
            })
          : null,
        hasAccessToReport(frameworkRoute.TCFD) &&
        !shouldBlockReportAccess(frameworkRoute.TCFD) &&
        (framework ? framework === frameworkRoute.TCFD : true)
          ? axios.request({
              method: CRUDMethods.GET,
              url: `${API_BASE_URL}${pillars.TCFD}/${companyId}/${companySubCategoryId}/${selectedYear}`,
              headers: {
                Authorization: `Bearer ${token}`
              },
              params: {},
              data: {}
            })
          : null,
        hasAccessToReport(frameworkRoute.CDP_SME) &&
        !shouldBlockReportAccess(frameworkRoute.CDP_SME) &&
        (framework ? framework === frameworkRoute.CDP_SME : true)
          ? axios.request({
              method: CRUDMethods.GET,
              url: `${API_BASE_URL}${pillars.CDP}/${companyId}/${selectedYear}`,
              headers: {
                Authorization: `Bearer ${token}`
              },
              params: {},
              data: {}
            })
          : null,
        hasAccessToReport(frameworkRoute.CDP_CORPORATE) &&
        !shouldBlockReportAccess(frameworkRoute.CDP_CORPORATE) &&
        (framework ? framework === frameworkRoute.CDP_CORPORATE : true)
          ? axios.request({
              method: CRUDMethods.GET,
              url: `${API_BASE_URL}${pillars.CDP_CORPORATE}/${companyId}/${selectedYear}`,
              headers: {
                Authorization: `Bearer ${token}`
              },
              params: {},
              data: {}
            })
          : null,
        hasAccessToReport(frameworkRoute.CBAM) &&
        !shouldBlockReportAccess(frameworkRoute.CBAM) &&
        (framework ? framework === frameworkRoute.CBAM : true)
          ? axios.request({
              method: CRUDMethods.GET,
              url: `${API_BASE_URL}${pillars.CBAM}/${companyId}/${companySubCategoryId}/${selectedYear}`,
              headers: {
                Authorization: `Bearer ${token}`
              },
              params: {},
              data: {}
            })
          : null,
        hasAccessToReport(frameworkRoute.SASB) &&
        !shouldBlockReportAccess(frameworkRoute.SASB) &&
        (framework ? framework === frameworkRoute.SASB : true)
          ? axios.request({
              method: CRUDMethods.GET,
              url: `${API_BASE_URL}${pillars.SASB}/${companyId}/${companySubCategoryId}/${selectedYear}`,
              headers: {
                Authorization: `Bearer ${token}`
              },
              params: {},
              data: {}
            })
          : null
      ]);

      const filteredResponse = response.filter((res) => res !== null) ?? [];

      setEsgPillars(
        filteredResponse?.flatMap((res) => {
          return res?.data.data;
        })
      );
      setPrevSelectedYear(selectedYear);
    } catch {}
  }
};

export default pillarsAPI;
